import api from './api';

// Kept out of lib/api.js deliberately: that file is being edited
// concurrently by another session, and this is the one call site this
// backfill card needs. Reuses api's shared axios instance (baseURL, auth
// interceptor) unchanged -- never a second axios config.
//
// Both Preview and Apply are out-of-band (202 + job id, JobStore-backed --
// same cohort-scaling shape as ConfirmedMatchCategoryBackfillPanel/api.js's
// categoryBackfill* calls): the candidate scan is a loosely-capped Mongo
// walk, not provably bounded work (CLAUDE.md section 13).
export const invoicePayerPaymentDateBackfillAPI = {
  previewStart: () => api.post('/admin/diagnostics/invoice-payer-payment-date-backfill/preview/start'),
  previewJobLatest: () => api.get('/admin/diagnostics/invoice-payer-payment-date-backfill/preview/job-latest'),
  applyStart: () => api.post('/admin/diagnostics/invoice-payer-payment-date-backfill/apply/start'),
  jobStatus: (jobId) => api.get(`/admin/diagnostics/invoice-payer-payment-date-backfill/job-status/${jobId}`),
  jobLatest: () => api.get('/admin/diagnostics/invoice-payer-payment-date-backfill/job-latest'),
};
